module.exports = __webpack_public_path__ + "static/media/EverydayCreativity.2ecd57a7.mp3";